<template>
  <div>
    <vs-table ref="table" :params="params" :options="options" @onCreateHeaderActionClicked="createBankAccount">
    </vs-table>
    <div ref="container"></div>
  </div>
</template>

<script>
  import VsTable from "../../../_framework/VsTable.vue";
  import EventBus from "../../../bus.js";
  import Vue from "vue";
  import BankAccountsModalButton from "../../../components/BankAccountsModalButton.vue";
  import { mapState, mapMutations, mapActions } from "vuex";
  import BaseService from "../../../_framework/api/BaseService.js";
  import SidebarNavDivider from "@coreui/vue/src/components/Sidebar/SidebarNavDivider";
  import SidebarNavDropdown from "@coreui/vue/src/components/Sidebar/SidebarNavDropdown";
  import SidebarNavLink from "@coreui/vue/src/components/Sidebar/SidebarNavLink";
  import SidebarNavTitle from "@coreui/vue/src/components/Sidebar/SidebarNavTitle";
  import SidebarNavItem from "@coreui/vue/src/components/Sidebar/SidebarNavItem";
  import SidebarNavLabel from "@coreui/vue/src/components/Sidebar/SidebarNavLabel";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";

  export default {
    name: "bi-access",
    created: () => {},
    components: {
      SidebarNavDivider,
      SidebarNavDropdown,
      SidebarNavLink,
      SidebarNavTitle,
      SidebarNavItem,
      SidebarNavLabel,
      VuePerfectScrollbar,
      VsTable
    },
    mounted() {
      this.$store.commit('ADD_ROW_TO_VS_TABLE_FEED', {
        firstName: 'ddd',
        lastName: 'asdjhcx',
        phoneNumber: '123456',
        city: 'kjh',
        province: 'uyc'
      });
     this.$store.commit('ADD_ROW_TO_VS_TABLE_FEED', {
       firstName: 'hgjgh',
       lastName: 'ddds',
       phoneNumber: '45125',
       city: 'jhug',
       province: 'jhg'
     });
     this.$store.commit('ADD_ROW_TO_VS_TABLE_FEED', {
       firstName: 'adxc',
       lastName: 'armin',
       phoneNumber: '8541254',
       city: 'mnbjf',
       province: 'fjhgb'
     });
     this.$store.commit('ADD_ROW_TO_VS_TABLE_FEED', {
       firstName: 'kjuhn',
       lastName: 'nvhfyr',
       phoneNumber: '322323',
       city: 'mnbfjh',
       province: 'hjhfngd'
     })
    },
    data() {
      return {
        access: {},
        show: true,
        params: {
          // entity: "products",
          list: [],
          headers: {
            firstName: {
              title: 'نام',
              type: 'text',
              rowAlignment: 'center'
            },
            lastName: {
              title: 'نام خانوادگی',
              type: 'text',
              rowAlignment: 'center'
            },
            phoneNumber: {
              title: 'شماره موبایل',
              type: 'text',
              rowAlignment: 'center'
            },
            city: {
              title: 'شهر',
              type: 'text',
              rowAlignment: 'center',
            },
            province: {
              title: 'استان',
              type: 'text',
              rowAlignment: 'center'
            }
          }
        },
        options: {
          hasActions: true,
          dataSourceType: "store",
          hasActionInHeader: true,
          onCreateHeaderActionClicked: true,
          clickableRows: true,
          getTopRightButtons: () => {
            let arr = [];
            let addItemButton = {
              component: "bank-accounts-modal-button",
              params: {
                mode: "create"
              }
            };
            arr.push(addItemButton);
            return arr;
          },
          onRowDubleClicked: row => {
            this.viewBankAccount(row);
          },
        },
        onRowClicked: row => {
          //
        },
        onEditClicked: (row, context) => {
          this.editBankAccount(row);
        }
      }
    },
    methods: {
      viewBankAccount(data) {
        this.showModal("view", data);
      },
      editBankAccount(data) {
        this.showModal("edit", data);
      },
      createBankAccount() {
        this.showModal("create");
      },
      showModal(_mode, _data) {
        let ComponentClass = Vue.extend(BankAccountsModalButton);
        let baModal = new ComponentClass({
          propsData: {
            account: _data,
            params: {
              mode: _mode
            }
          }
        });
        baModal.$mount();
        this.$refs.container.appendChild(baModal.$el);
        setTimeout(() => {
          baModal.openModal();
        }, 50);
      },
      getTopButtons() {
        let buttonsComponents = [];
        let addItemButton = Vue.component("vs-button", {
          template: `<button @clivk="onClick" class="btn iconed btn-success"><i class="icon-plus"></i><span>اضافه کردن حساب جدید</span></button>`,
          methods: {
            onClick() {
              this.$emit("onToggleHeaderForms");
            }
          }
        });
        buttonsComponents.push(addItemButton);
        return buttonsComponents;
      }
    },
    beforeMount() {
      this.options.access = checkAccess(this.$route.path);
      this.show = !!this.options.access;
    },
    computed: {
      ...mapState(["vsTableFeed"])
    }
  };
</script>
